import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ThumbnailList } from '../ThumbnailList';
import { Tooltip, TooltipContent, TooltipTrigger } from '../Tooltip';

const baseClasses = 'cursor-pointer select-none outline-none';

const StudyItem = ({
  date,
  description,
  numInstances,
  modalities,
  isActive,
  onClick,
  isExpanded,
  displaySets,
  activeDisplaySetInstanceUIDs,
  onClickThumbnail,
  onDoubleClickThumbnail,
  onClickUntrack,
  viewPreset = 'thumbnails',
  ThumbnailMenuItems,
  StudyMenuItems,
  StudyInstanceUID,
}: withAppTypes) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMobileDevice = /(Mobi|Android|iPhone|iPad|iPod)/.test(navigator.userAgent);
      setIsMobile(isMobileDevice);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleContentClick = event => {
    event.stopPropagation();
  };

  return (
    <div className="w-full rounded">
      {/* Header/Trigger */}
      <div
        className={classnames(
          isMobile
            ? baseClasses
            : `${
                isActive ? 'bg-secondary-dark' : 'hover:bg-accent bg-popover'
              } border-secondary-light border-t first:border-0`,
          baseClasses,
          'group w-full rounded'
        )}
        onClick={onClick}
        onKeyDown={() => {}}
        role="button"
        tabIndex={0}
      >
        {StudyMenuItems && (
          <div className="ml-2 flex items-center">
            <StudyMenuItems StudyInstanceUID={StudyInstanceUID} />
          </div>
        )}
      </div>

      {/* Content */}
      {isExpanded && (
        <div
          className={classnames(
            'overflow-hidden transition-all duration-200',
            isMobile ? 'px-2 py-2' : ''
          )}
          onClick={handleContentClick}
        >
          {displaySets && (
            <ThumbnailList
              thumbnails={displaySets}
              activeDisplaySetInstanceUIDs={activeDisplaySetInstanceUIDs}
              onThumbnailClick={onClickThumbnail}
              onThumbnailDoubleClick={onDoubleClickThumbnail}
              onClickUntrack={onClickUntrack}
              viewPreset={viewPreset}
              ThumbnailMenuItems={ThumbnailMenuItems}
            />
          )}
        </div>
      )}
    </div>
  );
};

StudyItem.propTypes = {
  date: PropTypes.string.isRequired,
  description: PropTypes.string,
  modalities: PropTypes.string.isRequired,
  numInstances: PropTypes.number.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  isExpanded: PropTypes.bool,
  displaySets: PropTypes.array,
  activeDisplaySetInstanceUIDs: PropTypes.array,
  onClickThumbnail: PropTypes.func,
  onDoubleClickThumbnail: PropTypes.func,
  onClickUntrack: PropTypes.func,
  viewPreset: PropTypes.string,
  StudyMenuItems: PropTypes.func,
  StudyInstanceUID: PropTypes.string,
};

export { StudyItem };
